import React from "react";
import { wrapCollectionLayout, EagerLoadImages } from "@quintype/components";
import TopStories from "./top-stories";
import SixStories from "./six-stories";
import SevenStories from "./seven-stories";
import SixStoyGrid from "./six-story-grid";
import SixTextStoryCards from "./six-text-story-cards";
import VideoCardSlider from "./video-slider";
import SingleCardSlider from "./single-card-slider";
import SingleBigCardSlider from "./single-big-card-slider";
import HoroscopeCollection from "./horoscope-collection";
import ThreeCardSlider from "./three-card-slider";
import ThreeColFourStories from "./three-col-four-stories";
import ThreeColFourStories2 from "./three-col-four-stories2";
import SliderWithMultipleBigCards from "./slider-with-multiple-big-cards";
import TwoCollectionWithTenStroies from "./two-collection-ten-stories";
import OpinionStories from "./opinion-stories";
import BillBoardCollectionAd from "./billboard-collection-ad";
import CollectionWidget from "./collection-widget";

// This should not be needed anymore as we are using Gumlet
function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    if (props.index === 0) {
      return (
        <EagerLoadImages predicate={(token) => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
      );
    } else {
      return React.createElement(f, props);
    }
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  if (f.nestedCollectionLimit) {
    wrappedComponent.nestedCollectionLimit = f.nestedCollectionLimit;
  }

  return wrappedComponent;
}

export default {
  TopStories: wrapEager(wrapCollectionLayout(TopStories)),
  SixStories: wrapEager(wrapCollectionLayout(SixStories)),
  SevenStories: wrapEager(wrapCollectionLayout(SevenStories)),
  ThreeCardSlider: wrapEager(wrapCollectionLayout(ThreeCardSlider)),
  VideoCardSlider: wrapEager(wrapCollectionLayout(VideoCardSlider)),
  SixTextStoryCards: wrapEager(wrapCollectionLayout(SixTextStoryCards)),
  OpinionStories: wrapEager(wrapCollectionLayout(OpinionStories)),
  HoroscopeCollection: wrapEager(wrapCollectionLayout(HoroscopeCollection)),
  SingleCardSlider: wrapEager(wrapCollectionLayout(SingleCardSlider)),
  SingleBigCardSlider: wrapEager(wrapCollectionLayout(SingleBigCardSlider)),
  SliderWithMultipleBigCards: wrapEager(wrapCollectionLayout(SliderWithMultipleBigCards)),
  TwoCollectionWithTenStroies: wrapEager(wrapCollectionLayout(TwoCollectionWithTenStroies)),
  SixStoyGrid: wrapEager(wrapCollectionLayout(SixStoyGrid)),
  ThreeColFourStories: wrapEager(wrapCollectionLayout(ThreeColFourStories)),
  ThreeColFourStories2: wrapEager(wrapCollectionLayout(ThreeColFourStories2)),
  BillBoardCollectionAd: wrapEager(wrapCollectionLayout(BillBoardCollectionAd)),
  CollectionWidget: wrapEager(wrapCollectionLayout(CollectionWidget)),
  defaultTemplate: wrapEager(wrapCollectionLayout(SixTextStoryCards))
};
